module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "checklist"
  }, [_vm._l((_vm.categories), function(category) {
    return _c('div', {
      key: category.meta.key,
      staticStyle: {
        "xxxxxbackground-color": "#fafafa",
        "max-width": "800px"
      }
    }, [_c('v-menu', {
      staticClass: "full-width",
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [(!_vm.clientOrEmail) ? _c('div', _vm._g({
            staticClass: "section-heading full-width hoverable",
            on: {
              "dblclick": function($event) {
                return _vm.editCategory(category)
              }
            }
          }, on), [_vm._v("\n                " + _vm._s(category.name) + "\n            ")]) : _vm._e()]
        }
      }], null, true)
    }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.$emit('add-category-document', category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Add " + _vm._s(category.name) + " Document")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": function($event) {
          return _vm.deleteCategory(category)
        }
      }
    }, [_c('v-list-item-title', [_vm._v("Delete Category")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.sortCategories
      }
    }, [_c('v-list-item-title', [_vm._v("Sort Categories")])], 1), _vm._v(" "), _c('v-list-item', {
      on: {
        "click": _vm.addCategory
      }
    }, [_c('v-list-item-title', [_vm._v("Add Another Category")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.policiesForCategory(category)), function(policy) {
      return _c('div', {
        key: policy.meta.key,
        staticClass: "item-pulse"
      }, [_c('v-menu', {
        staticClass: "xxxxdisplay-block hoverable",
        attrs: {
          "offset-y": "",
          "disabled": _vm.clientOrEmail
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('div', _vm._g({
              staticStyle: {
                "font-size": "20px",
                "color": "#1976d2",
                "padding": "2px 5px"
              },
              on: {
                "dblclick": function($event) {
                  return _vm.editPolicy(policy)
                }
              }
            }, on), [_vm._v(_vm._s(policy.name))])]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.editPolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit this Policy")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.sortPoliciesForCategory(category)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Sort " + _vm._s(category.name) + " Policies")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.deletePolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete this Policy")])], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.firstOptionForPolicy(policy).name) ? [_c('v-menu', {
        attrs: {
          "offset-y": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [(_vm.mode == 'Template') ? _c('b', _vm._g({
              staticClass: "hoverable",
              staticStyle: {
                "padding": "2px 5px"
              },
              on: {
                "dblclick": function($event) {
                  _vm.editOption(_vm.firstOptionForPolicy(policy))
                }
              }
            }, on), [_vm._v(_vm._s(_vm.firstOptionForPolicy(policy).name))]) : _vm._e()]
          }
        }], null, true)
      }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
        on: {
          "click": function($event) {
            _vm.editOption(_vm.firstOptionForPolicy(policy))
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Edit this Option")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            return _vm.sortOptionsForPolicy(policy)
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Sort " + _vm._s(policy.name) + " Options")])], 1), _vm._v(" "), _c('v-list-item', {
        on: {
          "click": function($event) {
            _vm.deleteOption(_vm.firstOptionForPolicy(policy))
          }
        }
      }, [_c('v-list-item-title', [_vm._v("Delete this Option")])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.documentsForOption(_vm.firstOptionForPolicy(policy))), function(document) {
        return [_c('div', {
          key: 'd-' + document.meta.key,
          staticClass: "no-print",
          staticStyle: {
            "float": "right",
            "margin-top": "10px"
          }
        }, [(!_vm.clientOrEmail) ? _c('v-menu', {
          attrs: {
            "close-on-content-click": false,
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "icon": ""
                }
              }, on), [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)]
            }
          }], null, true),
          model: {
            value: (document.meta.menuOpen),
            callback: function($$v) {
              _vm.$set(document.meta, "menuOpen", $$v)
            },
            expression: "document.meta.menuOpen"
          }
        }, [_vm._v(" "), (_vm.mode == 'Consultant') ? _c('div', {
          staticClass: "pa-3 white-background"
        }, [_c('v-switch', {
          staticClass: "compact",
          attrs: {
            "hide-details": "",
            "color": "green",
            "label": "Received"
          },
          on: {
            "change": function($event) {
              return _vm.switchReceived(document)
            }
          },
          model: {
            value: (document.received),
            callback: function($$v) {
              _vm.$set(document, "received", $$v)
            },
            expression: "document.received"
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('div', {
          on: {
            "click": function($event) {
              document.meta.menuOpen = false
            }
          }
        }, [_c('v-list', [_c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.addDocument(_vm.firstOptionForPolicy(policy).meta.key)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Add Document Here")])], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$emit('add-category-document', category)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Add Different " + _vm._s(category.name) + " Doc")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.editDocument(document)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Edit Document")])], 1), _vm._v(" "), (_vm.documentsForOption(_vm.firstOptionForPolicy(policy)).length > 1) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.sortDocumentsForOption(_vm.firstOptionForPolicy(policy))
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Sort Documents")])], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.deleteDocument(document)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Delete Document")])], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              _vm.deleteOption(_vm.firstOptionForPolicy(policy))
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Delete Entire Option")])], 1)], 1)], 1)]) : _vm._e()], 1), _vm._v(" "), _c('ChecklistDocument', {
          key: document.meta.key,
          attrs: {
            "document": document,
            "pageSettings": _vm.pageSettings
          },
          on: {
            "open": _vm.editDocument
          }
        })]
      }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            _vm.addDocument(_vm.firstOptionForPolicy(policy).meta.key)
          }
        }
      }, [_vm._v("Add a Document")]), _vm._v(" \n                ")]) : _vm._e()] : _vm._e(), _vm._v(" "), ((_vm.optionsForPolicy(policy).length > 1) && _vm.mode != 'Email') ? _c('div', {
        staticClass: "mb-3"
      }, [_c('span', [_vm._v("Other Options: ")]), _vm._v(" "), _vm._l((_vm.remainingOptionsForPolicy(policy)), function(option, index) {
        return _c('span', {
          key: index + 1
        }, [_c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return _vm.optionLinkClicked(option)
            }
          }
        }, [_vm._v(_vm._s(option.name))]), _vm._v("  \n                ")])
      })], 2) : _vm._e(), _vm._v(" "), ((_vm.optionsForPolicy(policy).length > 1) && _vm.mode == 'Email') ? _c('div', {
        staticClass: "mb-3",
        staticStyle: {
          "color": "#888"
        }
      }, [_vm._v("\n                There are other options available for this one. Go to the online checklist and you can switch between them.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'Template') ? _c('span', [_c('a', {
        attrs: {
          "href": ""
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.addOption(policy.meta.key)
          }
        }
      }, [_vm._v("Add an Option")]), _vm._v(" \n            ")]) : _vm._e()], 2)
    }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.addPolicy(category.name)
        }
      }
    }, [_vm._v("Add a Policy")]), _vm._v(" \n        ")]) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.mode == 'Template') ? _c('div', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addCategory($event)
      }
    }
  }, [_vm._v("Add a Category")]), _vm._v(" \n    ")]) : _vm._e()], 2), _vm._v(" "), _c('AdvancedDialog', {
    attrs: {
      "record": _vm.editDialog.record,
      "settings": _vm.editDialog.settings,
      "fields": _vm.editDialog.fields
    },
    on: {
      "save": _vm.saveRecord,
      "delete": _vm.deleteRecord,
      "menu": _vm.editDialogMenu
    }
  }), _vm._v(" "), _c('SortDialog', {
    attrs: {
      "items": _vm.sortDialog.items,
      "dataRef": _vm.sortDialog.dataRef,
      "settings": _vm.sortDialog.settings
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b79abc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SupplierChecklist/ChecklistDetails.vue
// module id = 2502
// module chunks = 1